import { createAction } from '@reduxjs/toolkit';

import { withPayloadType } from 'utils/payloadType';

import {
  REMUNERATION_NAVIGATION_ACTIONS,
  REMUNERATION_FORM_MODE,
} from './constants';

const setSelectedRemunerationModeAction = createAction(
  REMUNERATION_NAVIGATION_ACTIONS.SET_MODE,
  withPayloadType<REMUNERATION_FORM_MODE>(),
);

const resetRemunerationModeAction = createAction(
  REMUNERATION_NAVIGATION_ACTIONS.RESET_MODE,
);

export { setSelectedRemunerationModeAction, resetRemunerationModeAction };

export type ActionTypes =
  | ReturnType<typeof setSelectedRemunerationModeAction>
  | ReturnType<typeof resetRemunerationModeAction>;
